import { render, staticRenderFns } from "./SinglePanelPage.vue?vue&type=template&id=275c9ec2&"
import script from "./SinglePanelPage.vue?vue&type=script&lang=js&"
export * from "./SinglePanelPage.vue?vue&type=script&lang=js&"
import style0 from "./SinglePanelPage.vue?vue&type=style&index=0&lang=scss&scoper=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports